import { XStylesSettings } from '@shared/types/types';
import { SwitcherProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { useId } from 'react';

const Switcher = (props: SwitcherProps) => {
  const {
    size = 'medium',
    isDisabled = false,
    isActive = false,
    variant = 'default',
    changeFunction,
    settings,
    id,
  } = props;

  // Раньше id был захардкожен как "switch": несколько свитчеров на одной
  // странице давали дублирующиеся id и невалидный DOM.
  const generatedId = useId();

  return (
    <input
      type="checkbox"
      role="switch"
      id={id ?? generatedId}
      onChange={changeFunction}
      disabled={isDisabled}
      checked={isActive}
      {...stylex.props(
        styles.base,
        styles[size](isActive),
        styles[variant](isActive, isDisabled),
        settings as XStylesSettings
      )}
    />
  );
};

export default Switcher;
